import config from '../config';
import { AUTOMATIC } from './markAsDoneModes';
import { TYPE_SCORM } from '../file/types';
import { checkIsAsset } from 'types/content/utils';
/**
 * Automatically mark assets as done if:
 * - The asset is a SCORM course
 * - The feature flag `autoMarkAsDone` is enabled and the asset has an `automatic` mark as done mode
 * - `autoMarkAsDone` is enabled, while `manualMarkAsDone` is not enabled, and the asset has no mark as done mode
 */

export default function hasAutoCompleteEnabled(_ref) {
  var assetType = _ref.assetType,
    markAsDoneMode = _ref.markAsDoneMode;
  if (assetType === TYPE_SCORM) {
    return true;
  }
  if (!config.autoMarkAsDone || !checkIsAsset({
    type: assetType
  })) {
    return false;
  }
  return markAsDoneMode === AUTOMATIC || !markAsDoneMode && !config.manualMarkAsDone;
}